import * as React from 'react';

export const SolvdCircledCheck = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M25.5 37.25L33.3333 45.0833L49 29.4167M72.5 37.25C72.5 56.718 56.718 72.5 37.25 72.5C17.782 72.5 2 56.718 2 37.25C2 17.782 17.782 2 37.25 2C56.718 2 72.5 17.782 72.5 37.25Z"
			stroke="#12856A"
			strokeWidth="4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
